module.exports = __webpack_public_path__ + "media/images/logo/charica_logo-cd710bdcaef0fe1655d9d541925f00ff.png";